import { render, staticRenderFns } from "./FlightDetails.vue?vue&type=template&id=8cfb1522"
import script from "./FlightDetails.vue?vue&type=script&lang=js"
export * from "./FlightDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports